import React from "react";
import "./style.less";

type Props = {
  height?: number;
  m?: number;
  n?: number;
  value?: number;
};
const Progress = (props: Props) => (
  <span className="wsc_progress" style={{ height: props.height }}>
    <span className="value" style={{ width: `${props.value ?? Math.round((props.m! / props.n!) * 100)}%` }} />
  </span>
);
export default Progress;
